import React, { useEffect, useState } from "react";
import {
    addCandidate,
    getCandidatesByStatus,
    updateCandidateStatus
} from "../../service/apiService";
import "./HiringBoard.css";

const TABS = [
    { label: "New", value: "NEW" },
    { label: "Screening", value: "SCREENING" },
    { label: "Shortlisted", value: "SHORTLISTED" },
    { label: "Interview Scheduled", value: "INTERVIEW_SCHEDULED" },
    { label: "Selected", value: "SELECTED" },
    { label: "Rejected", value: "REJECTED" }
];

const HiringBoard = () => {
    const [activeTab, setActiveTab] = useState("NEW");
    const [candidates, setCandidates] = useState([]);
    const [loading, setLoading] = useState(false);

    const [commentBox, setCommentBox] = useState({});
    const [form, setForm] = useState({
        full_name: "",
        email: "",
        phone: "",
        position_applied: "",
        experience_years: "",
        resume: null
    });

    useEffect(() => {
        loadCandidates();
    }, [activeTab]);

    const loadCandidates = async () => {
        setLoading(true);
        const res = await getCandidatesByStatus(activeTab);
        if (res.success) setCandidates(res.data);
        setLoading(false);
    };

    const handleFormChange = (e) => {
        const { name, value, files } = e.target;
        setForm({ ...form, [name]: files ? files[0] : value });
    };

    const submitCandidate = async (e) => {
        e.preventDefault();

        const fd = new FormData();
        Object.entries(form).forEach(([k, v]) => fd.append(k, v));
        fd.append("created_by", 1); // logged-in staff id

        const res = await addCandidate(fd);
        if (res.success) {
            setForm({
                full_name: "",
                email: "",
                phone: "",
                position_applied: "",
                experience_years: "",
                resume: null
            });
            document.getElementById("resumeInput").value = "";
            loadCandidates();
        }
    };

    const changeStatus = async (candidate, newStatus) => {
        await updateCandidateStatus({
            candidate_id: candidate.id,
            new_status: newStatus,
            comment: commentBox[candidate.id] || "",
            staff_id: 1
        });
        setCommentBox({ ...commentBox, [candidate.id]: "" });
        loadCandidates();
    };

    return (
        <div className="hiring-page">
            <div className="hiring-header">
                <h2>Hiring Pipeline</h2>
                <p>Track candidates from application to selection</p>
            </div>

            {/* ADD CANDIDATE */}
            <form className="candidate-form" onSubmit={submitCandidate}>
                <h4>Add Candidate</h4>

                <div className="form-grid">
                    <input
                        name="full_name"
                        placeholder="Full Name *"
                        value={form.full_name}
                        required
                        onChange={handleFormChange}
                    />
                    <input
                        name="email"
                        placeholder="Email"
                        value={form.email}
                        onChange={handleFormChange}
                    />
                    <input
                        name="phone"
                        placeholder="Phone"
                        value={form.phone}
                        onChange={handleFormChange}
                    />
                    <input
                        name="position_applied"
                        placeholder="Position Applied"
                        value={form.position_applied}
                        onChange={handleFormChange}
                    />
                    <input
                        name="experience_years"
                        placeholder="Experience (Years)"
                        value={form.experience_years}
                        onChange={handleFormChange}
                    />
                    <input
                        type="file"
                        id="resumeInput"
                        name="resume"
                        onChange={handleFormChange}
                    />
                </div>

                <button type="submit">Add Candidate</button>
            </form>

            {/* TABS */}
            <div className="hiring-tabs">
                {TABS.map(tab => (
                    <button
                        key={tab.value}
                        className={activeTab === tab.value ? "active" : ""}
                        onClick={() => setActiveTab(tab.value)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* LIST */}
            <div className="candidate-list">
                {loading && <div className="info">Loading candidates…</div>}
                {!loading && candidates.length === 0 && (
                    <div className="info">No candidates found</div>
                )}

                {candidates.map(c => (
                    <div key={c.id} className="candidate-card">
                        <div className="candidate-info">
                            <h4>{c.full_name}</h4>

                            <span className="muted">
                                {c.position_applied || "—"} • {c.experience_years} yrs exp
                            </span>

                            {c.comments && c.comments.length > 0 && (
                                <div className="comment-thread">
                                    {c.comments.map((cm, i) => (
                                        <div key={i} className="comment-item">
                                            <div className="comment-header">
                                                <span className="comment-author">
                                                    {cm.commented_by}
                                                </span>
                                                <span className="comment-time">
                                                    {new Date(cm.created_at).toLocaleString()}
                                                </span>
                                            </div>

                                            <p className="comment-text">{cm.comment}</p>
                                        </div>
                                    ))}
                                </div>
                            )}

                        </div>


                        <div className="candidate-meta">
                            {c.resume_path && (
                                <a href={`/${c.resume_path}`} target="_blank" rel="noreferrer">
                                    View Resume
                                </a>
                            )}
                        </div>

                        {/* COMMENT + STATUS */}
                        <div className="candidate-actions">
                            <textarea
                                placeholder="Add comment / feedback"
                                value={commentBox[c.id] || ""}
                                onChange={(e) =>
                                    setCommentBox({ ...commentBox, [c.id]: e.target.value })
                                }
                            />

                            <div className="action-row">
                                <select
                                    value={c.current_status}
                                    onChange={(e) => changeStatus(c, e.target.value)}
                                >
                                    {TABS.map(t => (
                                        <option key={t.value} value={t.value}>
                                            {t.label}
                                        </option>
                                    ))}
                                </select>

                                <button
                                    className="save-status"
                                    onClick={() => changeStatus(c, c.current_status)}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HiringBoard;
